import { useMemo, useState } from 'react'
import { Box } from '@mui/material'
import StoriesPageHero from '../components/stories/StoriesPageHero'
import StoriesLoadMoreButton from '../components/stories/StoriesLoadMoreButton'
import HomeStoryCard from '../components/home/HomeStoryCard'
import {
  STORIES_INITIAL_COUNT,
  STORIES_LOAD_MORE_COUNT,
  buildStoriesList,
} from '../data/storiesContent'
import { mobilePaddingX } from '../theme/mobileLayout'
import { programSectionGap } from '../components/programs/programLayout'

const sectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export default function StoriesPage() {
  const [visibleCount, setVisibleCount] = useState(STORIES_INITIAL_COUNT)

  const visibleStories = useMemo(() => buildStoriesList(visibleCount), [visibleCount])

  const handleLoadMore = () => {
    setVisibleCount((count) => count + STORIES_LOAD_MORE_COUNT)
  }

  return (
    <Box>
      <StoriesPageHero />

      <Box
        sx={{
          ...sectionWrapperSx,
          mt: { xs: 4, md: 6, lg: '150px' },
          pb: { xs: 8, md: 12, lg: '140px' },
        }}
      >
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                lg: 'repeat(3, 1fr)',
              },
              gap: { xs: 5, md: 5, lg: '40px' },
              rowGap: { xs: 5, md: '48px', lg: '60px' },
              alignItems: 'start',
            }}
          >
            {visibleStories.map((story) => (
              <HomeStoryCard
                key={story.id}
                title={story.title}
                date={story.date}
                image={story.image}
                to={`/stories/${story.slug}`}
              />
            ))}
          </Box>

          <Box sx={{ mt: { xs: 6, md: '80px' } }}>
            <StoriesLoadMoreButton onClick={handleLoadMore} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
